<div [id]="id" *ngIf="display" class="row auction section event-page__silent-auction position-relative">
    <div class="col-12 justify-content-center section__title auction-title" [innerHTML]="title"></div>
    <div class="col-12 justify-content-center section__all-items-link">
        <a [href]="url" target="_blank"> View All Items</a>
    </div>
    <div class="col-12" style="padding: 0 12vw;">
        <div class="swiper" #swiper>
            <div class="swiper-wrapper swiper-container--silent-auction"></div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
            <!-- Add Arrows -->

        </div>
        <div class="swiper-button-next swiper-button-next--pagination" [ngClass]="id">
            <img class="image" src="/images/svg/event-page/right-arrow-circle.svg">
        </div>
        <div class="swiper-button-prev swiper-button-prev--pagination" [ngClass]="id">
            <img class="image" src="/images/svg/event-page/left-arrow-circle.svg">
        </div>
    </div>
</div>